module.exports = __webpack_public_path__ + "static/media/icon-relatorio.bed54179.svg";